import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const MessageNotificationIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 15.805a2 2 0 0 1-2 2H7l-4 4v-16a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
